import _extends from 'babel-runtime/helpers/extends';

import { crmQueryImportNumAPI, crmQueryImportInfoAPI, crmDownImportErrorAPI, filedGetFieldAPI } from '@/api/crm/common';
import { crmCustomerExcelImportAPI, crmCustomerDownloadExcelAPI, crmCustomerPoolExcelImportAPI, crmCustomerPoolNameListAPI, crmCustomerPoolDownloadExcelAPI } from '@/api/crm/customer';
import { crmLeadsExcelImportAPI, crmLeadsDownloadExcelAPI } from '@/api/crm/leads';
import { crmContactsExcelImportAPI, crmContactsDownloadExcelAPI } from '@/api/crm/contacts';
import { crmProductExcelImportAPI, crmProductDownloadExcelAPI } from '@/api/crm/product';

import { XhUserCell } from '@/components/CreateCom';
import CRMImportHistory from './CRMImportHistory';

import { mapGetters } from 'vuex';
import crmTypeModel from '@/views/crm/model/crmTypeModel';
import { downloadExcelWithResData, verifyFileTypeWithFileName } from '@/utils';
import Lockr from 'lockr';
import merge from '@/utils/merge';

var DefaultProps = {
  typeName: '', // 模块名称
  historyShow: true,
  ownerSelectShow: false,
  poolSelectShow: false,
  repeatHandleShow: true,
  importParams: null, // 导入参数
  repeatRuleShow: true, // 步骤二的重复规则是否展示
  importRequest: null, // 导入请求
  templateRequest: null // 模板请求
};

export default {
  name: 'CRMImport', // 文件导入
  components: {
    XhUserCell: XhUserCell,
    CRMImportHistory: CRMImportHistory
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // CRM类型
    crmType: {
      type: String,
      default: ''
    },
    props: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 是有缓存的信息展示的页面 是否完成状态
    cacheShow: {
      type: Boolean,
      default: false
    },
    cacheDone: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      fieldList: [],
      repeatHandling: 1, // 	1 覆盖，0跳过
      file: { name: '' },
      user: [],

      // 公海数据
      pool_id: '',
      poolList: [],

      stepsActive: 1,
      stepList: [{
        icon: 'wk wk-upload',
        title: '上传文件',
        status: 'wait'
      }, {
        icon: 'wk wk-data-import',
        title: '导入数据',
        status: 'wait'
      }, {
        icon: 'wk wk-success',
        title: '导入完成',
        status: 'wait'
      }],
      resultData: null,
      processData: {
        count: 0,
        status: ''
      },
      messageId: null,
      intervalTimer: null,

      historyPopoverShow: false
    };
  },

  computed: _extends({}, mapGetters(['userInfo']), {
    crmTypeName: function crmTypeName() {
      if (this.props && this.props.typeName) {
        return this.props.typeName;
      }

      return {
        customer: '客户',
        leads: '线索',
        contacts: '联系人',
        product: '产品'
      }[this.crmType] || '';
    },
    importLoadingText: function importLoadingText() {
      if (this.processData.count) {
        return '\u6570\u636E\u5BFC\u5165\u4E2D\uFF08\u5F53\u524D\u5DF2\u5BFC\u5165' + this.processData.count + '\u6761\uFF09';
      }

      return '数据导入中';
    },
    sureTitle: function sureTitle() {
      return {
        1: '立即导入',
        2: '最小化',
        3: '确定'
      }[this.stepsActive];
    },
    showCancel: function showCancel() {
      return this.stepsActive != 2;
    },
    fieldUniqueInfo: function fieldUniqueInfo() {
      var uniqueList = this.fieldList.filter(function (item) {
        return item.is_unique == 1;
      });

      return uniqueList.map(function (item) {
        return item.name;
      }).join('/') || '无';
    },
    config: function config() {
      return merge(_extends({}, DefaultProps), this.props || {});
    }
  }),
  watch: {
    cacheShow: {
      handler: function handler(val) {
        // 展示缓存
        if (val) {
          this.$emit('update:cacheShow', false);
          var beforeImportInfo = Lockr.get('crmImportInfo');
          if (beforeImportInfo && beforeImportInfo.messageId) {
            this.loading = true;
            this.messageId = beforeImportInfo.messageId;
            this.stepList[0].status = 'finish';

            if (this.cacheDone) {
              this.stepList[1].status = 'finish';
              this.stepsActive = 3;
              this.thirdQueryResult();
            } else {
              this.stepsActive = 2;
              this.stepList[1].status = 'process';
            }

            this.loopSecondQueryNum();
          }
        }
      },

      immediate: true
    },

    show: function show(val) {
      if (val) {
        // 阶段一展示 需要获取的信息
        if (this.stepsActive == 1) {
          if (this.userInfo) {
            this.user = [this.userInfo];
          }

          if (this.config.poolSelectShow) {
            this.getPoolList();
          }

          if (this.config.repeatRuleShow && this.config.repeatHandleShow) {
            this.getField();
          }
        }
      } else {
        if (this.stepsActive == 3) {
          this.resetData();
        }

        this.fieldList = [];
      }
    },

    stepsActive: function stepsActive() {
      this.$emit('status', {
        1: 'wait',
        2: 'process',
        3: 'finish'
      }[this.stepsActive]);
    }

    // file() {
    //   this.getFirstStepStatus()
    // },

    // user() {
    //   this.getFirstStepStatus()
    // }

  },
  created: function created() {},

  methods: {
    sureClick: function sureClick() {
      var _this = this;

      if (this.stepsActive == 1) {
        if (this.stepList[0].status == 'finish') {
          this.stepList[1].status = 'process';
          this.stepsActive = 2;
          this.firstUpdateFile(function (res) {
            _this.messageId = res.data;

            // 写入本次缓存
            Lockr.set('crmImportInfo', {
              messageId: _this.messageId,
              crmProps: _this.config,
              crmType: _this.crmType
            });

            _this.loopSecondQueryNum();
          });
        } else {
          if (!this.file.name) {
            this.$message.error('请选择导入文件');
          } else if (this.config.ownerSelectShow && (!this.user || this.user.length == 0)) {
            this.$message.error('请选择负责人');
          }
        }
      } else {
        this.closeView();
      }
    },


    /**
     * 第一步上传
     */
    firstUpdateFile: function firstUpdateFile(result) {
      var _this2 = this;

      var params = {};
      params.config = this.repeatHandling;
      params.file = this.file;
      if (this.config.ownerSelectShow) {
        params.owner_user_id = this.user.length > 0 ? this.user[0].id : '';
      }
      if (this.config.poolSelectShow) {
        params.pool_id = this.pool_id;
      }

      var request = this.config.importRequest || {
        customer: this.config.poolSelectShow ? crmCustomerPoolExcelImportAPI : crmCustomerExcelImportAPI,
        leads: crmLeadsExcelImportAPI,
        contacts: crmContactsExcelImportAPI,
        product: crmProductExcelImportAPI
      }[this.crmType];
      this.loading = true;
      if (this.config.importParams) {
        params = _extends({}, params, this.config.importParams);
      }
      request(params).then(function (res) {
        if (result) {
          result(res);
        }
      }).catch(function () {
        if (result) {
          result(false);
        }
        _this2.loading = false;
      });
    },


    /**
     * 第二步查询数量
     */
    loopSecondQueryNum: function loopSecondQueryNum() {
      var _this3 = this;

      this.secondQueryNum();
      this.intervalTimer = setInterval(function () {
        if (_this3.processData.status == 'end') {
          clearInterval(_this3.intervalTimer);
          _this3.intervalTimer = null;
          _this3.thirdQueryResult();
        } else {
          _this3.secondQueryNum();
        }
      }, 2000);
    },
    secondQueryNum: function secondQueryNum() {
      var _this4 = this;

      crmQueryImportNumAPI({ messageId: this.messageId }).then(function (res) {
        if (res.data === '') {
          _this4.processData.status = 'end';
        } else {
          _this4.processData.status = '';
          _this4.processData.count = res.data;
        }
      }).catch(function () {
        // this.processData.status = 'err'
      });
    },


    /**
     * 第三部 查询结果
     */
    thirdQueryResult: function thirdQueryResult() {
      var _this5 = this;

      crmQueryImportInfoAPI({ messageId: this.messageId }).then(function (res) {
        _this5.loading = false;
        _this5.stepList[1].status = 'finish';
        _this5.stepsActive = 3;
        _this5.$emit('status', 'finish');
        if (res) {
          _this5.resultData = res.data;
          if (res.data.error > 0) {
            _this5.stepList[2].status = 'error';
          } else {
            _this5.stepList[2].status = 'finish';
          }
        }
      }).catch(function () {});
    },


    /**
     * 下载错误模板
     */
    downloadErrData: function downloadErrData() {
      var _this6 = this;

      this.loading = true;
      crmDownImportErrorAPI({ name: '导入错误数据', path: this.resultData.error_file_path }).then(function (res) {
        downloadExcelWithResData(res);
        _this6.loading = false;
      }).catch(function () {
        _this6.loading = false;
      });
    },


    // 下载模板操作
    download: function download() {
      var request = this.config.templateRequest || {
        customer: this.config.poolSelectShow ? crmCustomerPoolDownloadExcelAPI : crmCustomerDownloadExcelAPI,
        leads: crmLeadsDownloadExcelAPI,
        contacts: crmContactsDownloadExcelAPI,
        product: crmProductDownloadExcelAPI
      }[this.crmType];
      request(this.config.templateParams || { pool_id: this.config.poolSelectShow && this.pool_id }).then(function (res) {
        downloadExcelWithResData(res);
      }).catch(function () {});
    },

    // 选择文件
    selectFile: function selectFile() {
      document.getElementById('importInputFile').click();
    },

    /** 图片选择出发 */
    uploadFile: function uploadFile(event) {
      var files = event.target.files;
      var file = files[0];
      if (verifyFileTypeWithFileName(file.name)) {
        this.file = file;
        // 阶段一状态
        this.getFirstStepStatus();
      }
      event.target.value = '';
    },

    // 用户选择
    userSelect: function userSelect(data) {
      if (data.value && data.value.length > 0) {
        this.user = data.value;
      } else {
        this.user = [];
      }

      // 阶段一状态
      this.getFirstStepStatus();
    },
    getFirstStepStatus: function getFirstStepStatus() {
      // 阶段一状态
      var hasFile = this.file && this.file.size;
      var hasUser = this.user && this.user.length > 0;

      if (this.config.ownerSelectShow) {
        this.stepList[0].status = hasFile && hasUser ? 'finish' : 'wait';
      } else {
        this.stepList[0].status = hasFile ? 'finish' : 'wait';
      }
    },


    /**
     * 公海数据
     */
    getPoolList: function getPoolList() {
      var _this7 = this;

      crmCustomerPoolNameListAPI().then(function (res) {
        _this7.poolList = res.data || [];
        _this7.pool_id = _this7.poolList.length > 0 ? _this7.poolList[0].pool_id : '';
      }).catch(function () {});
    },


    // 关闭操作
    closeView: function closeView() {
      this.$emit('update:show', false);
      if (this.stepsActive == 3) {
        this.$bus.emit('import-crm-done-bus', this.crmType);
        Lockr.rm('crmImportInfo');
      }
      this.$emit('close', this.stepsActive == 3 ? 'finish' : '');
    },


    /**
     * 重置页面数据
     */
    resetData: function resetData() {
      this.repeatHandling = 1;
      this.file = { name: '' };
      this.user = [];

      this.stepsActive = 1;
      this.stepList = [{
        icon: 'wk wk-upload',
        title: '上传文件',
        status: 'wait'
      }, {
        icon: 'wk wk-data-import',
        title: '导入数据',
        status: 'wait'
      }, {
        icon: 'wk wk-success',
        title: '导入完成',
        status: 'wait'
      }];
      this.resultData = null;
      this.processData = {
        count: 0,
        status: ''
      };
      this.messageId = null;
    },


    /**
     * 获取验证字段
     */
    getField: function getField() {
      var _this8 = this;

      var params = {
        types: crmTypeModel[this.crmType],
        module: 'crm',
        action: 'save',
        controller: this.crmType
      };

      filedGetFieldAPI(params).then(function (res) {
        _this8.fieldList = res.data;
      }).catch(function () {});
    }
  }
};